<template>
  <div>
    <div class="top">
      <div style="width:1400px; margin: 0 auto ; position: relative;">
        <div class="left">
          <img :src="require('@/assets/xh_title.png')" style="height: 75px; margin-top: 20px">
        </div>
        <div style="position: absolute; right: 110px; line-height: 120px; top: 0">
          <el-input
              ref="searchInput"
              v-model="searchInput"
              class="all-search"
              style="width: 240px"
              placeholder="请输入关键词"
              @keyup.enter.native="totalSearch()">
            <template slot="suffix">
              <i
                  class="el-icon-search"
                  style="color: #033777; margin-right: 10px; cursor: pointer"
                  @click="totalSearch()"></i>
            </template>
          </el-input>
          <div style="display: inline-block" v-if="!userInfo.nickname">
            &nbsp; &nbsp; &nbsp;
            <span class="header-button" @click="toLR('login')">登录</span>
            &nbsp;<span style="color: #aaa">|</span>&nbsp;
            <span class="header-button" @click="toLR('regist')">注册</span>
            &nbsp;<span style="color: #aaa" v-if="oldLink">|</span>&nbsp;
            <span v-if="oldLink" class="header-button" @click="toOld">[返回旧版]</span>
          </div>
          <div style="display: inline-block" v-else>
            <div style="font-size: 12px">
              &nbsp;&nbsp;&nbsp;欢迎您，{{ userInfo.nickname }}&nbsp;&nbsp;
              <span class="header-button" @click="logout">[退出登录]</span>
              &nbsp;<span style="color: #aaa" v-if="oldLink">|</span>&nbsp;
              <span class="header-button" @click="toOld" v-if="oldLink">[返回旧版]</span>
            </div>
          </div>

        </div>
      </div>

    </div>
    <div class="right">
      <div style="display: flex; width: 1400px; margin: 0 auto">
        <div class="dropdown-container" :class="header === '首页'? 'now-class now-container':''" @click="toIndex">
          <div class="drop-title">
            首页
          </div>
        </div>
        <div
            v-for="i in menuList"
            class="dropdown-container"
            :key="i.id"
            :class="header === i.name? 'now-class now-container':''"
            @click="toPath(`/sub-index/${i.name}/${i.children[0].name}`)"
        >
          <div class="drop-title">
            {{ i.name }}
          </div>
          <div class="dropdown-content" v-if="i.children">
            <div class="drop-class" v-for="j in i.children" :key="j.id"
                 @click.stop="toPath(`/sub-index/${i.name}/${j.name}`)">{{ j.name }}
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {getMenuList} from "@/api/menu";
import {listToTree} from "@/plugins/utils";
import {getDictList} from "@/api/dict";

export default {
  name: "myHeader",
  props: {
    header: {
      type: String,
      default: '首页'
    },
    userInfo: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      searchInput: '',
      menuList: [],
      oldLink: ''
    }
  },
  mounted() {
    this.setTopWidth();
    this.getMenuList()
    this.getOldLink()
    window.addEventListener('resize', this.setTopWidth);
  },
  methods: {
    toLR(type) {
      this.$router.push({
        path: '/loginRegist?type=' + type
      })
    },
    toOld() {
      window.location.href = this.oldLink
    },
    // 旧版链接
    getOldLink() {
      getDictList({
        name: '旧版链接',
        value: '福建省质量检验协会',
        pagesize: 1,
        pagenow: 1
      }).then(res => {
        if (res && res.length > 0) {
          if (res[0].pn)
            this.oldLink = res[0].pn
          else this.oldLink = ''
        } else {
          this.oldLink = ''
        }
      })
    },
    logout() {
      localStorage.removeItem('loginTime')
      localStorage.removeItem('userInfo')
      this.$emit('logout')

    },
    // 全局搜索
    totalSearch() {
      this.toPath('/article-list/all|' + this.searchInput)
      this.$refs.searchInput.blur()
      this.searchInput = ''
    },
    toIndex() {
      this.$emit('top')
      this.toPath('/')
    },
    setTopWidth() {

      const viewportWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

      document.querySelector('.top').style.width = `${viewportWidth}px`;

    },
    toPath(path) {
      if (path === this.$route.path) {
        window.scrollTo(0, 0);
      }
      if (path && path !== this.$route.path) {
        this.$router.push({
          path
        })
      }
    },
    getMenuList() {
      getMenuList({
        order: 'order by sort'
      }).then(res => {
        if (res) {
          var menu = listToTree(res, null, 'id', 'pid')
          this.menuList = menu.filter(f => {
            return f.view === 'layout/web-title'
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.header-button {
  font-size: 12px;
  cursor: pointer;
  color: #0f6ee2;
}

.header-button:hover {
  color: #409EFF;
}

.all-search >>> .el-input__inner {
  border-radius: 20px;
}

/*.now-class{*/
/*  background: #0f6ee2;*/
/*  transform: scaleY(1.1);*/
/*  position: relative;*/
/*  border-bottom-right-radius: 10px;*/
/*  z-index: 999;*/
/*  transition: all 0.15s ease;*/
/*}*/
.now-class {
  background: #0f6ee2;
  position: relative;
  border-bottom-right-radius: 10px;
  z-index: 999;
  transition: all 0.15s ease;
}

/* 使用伪元素模拟 scaleY(1.1) 的凸出效果 */
.now-class::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px; /* 和 .drop-title 高度一致 */
  background-color: #0f6ee2;
  transform: scaleY(1.1);
  font-size: 1.18em;
  /*transform-origin: top center;*/
  border-bottom-right-radius: 10px;
  z-index: -1;
  transition: transform 0.15s ease;
}

.dropdown-container {
  /*padding: 10px;*/
  position: relative;
  justify-content: center;
  /*display: inline-block;*/
  cursor: pointer;
  /*margin-right: 30px;*/
  font-weight: bold;
  height: 60px;
  transition: all 0.3s ease;
  display: inline-flex;
  flex: 1;
}

/* 定义下划线样式 */
.dropdown-container::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0%;
  height: 2px;
  background-color: #20cede;;
  transition: all 0.3s ease;
}

/* 下拉框隐藏初始状态 */
.dropdown-content {
  overflow-y: auto;
  visibility: hidden;
  opacity: 0;
  position: absolute;
  top: calc(100% + 2px); /* 距离上方元素的距离，包括下划线高度 */
  left: 0%;
  width: 100%;
  background-color: #f9f9f9;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  padding: 0;
  font-weight: 400;
  z-index: 1000;
  text-align: center;
  color: #0b573e;
  /*font-size: 20px;*/
  transition: visibility 0s linear 0.3s, opacity 0.3s ease;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

/* 当鼠标悬停时，下划线变宽并显示下拉框 */
.dropdown-container:hover::after {
  width: 100%;
}

.dropdown-container:hover .dropdown-content {
  visibility: visible;
  opacity: 1;
  transition-delay: 0s; /* 去除延迟，立即显示 */
}

.drop-title {
  line-height: 60px;
}

.drop-class {
  color: #0b2d57;
  line-height: 40px;
  font-size: 16px;
  padding: 0 10px;
}

.drop-class:hover {
  background: rgba(92, 162, 241, 0.2);
}

.top {
  width: 100% !important;
  /*min-width: 100%;*/
  /*min-width: max-content;*/
  height: 120px;
  /* 添加以下两条规则以确保背景色填充整个视窗宽度 */
  z-index: 100; /* 可能需要根据实际情况调整z-index */
  /*background: rgb(7, 55, 99);*/
  /*background: #fff;*/
  background: url("../assets/bg.png");
  background-size: 100% 100px;
  /*background-image: linear-gradient(to right, #0a3574, #004d86, #006391, #007896, #068d99);*/
  display: flex;
  position: relative;

  /*overflow: hidden;*/
}

.left {
  width: 600px;
  height: 100px;
  display: flex;
  /*margin-left: 15%;*/
}

.right {
  color: white;
  font-size: 1.15em;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  background: #1e50ae;
  box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.2);
}

/*@media (max-width: 1200px) {*/

/*  .right {*/
/*    display: none;*/
/*  }*/
/*}*/
.title {
  color: white;
  font-weight: 400;
  font-size: 30px;
  line-height: 75px;
}

.sub-title {
  color: white;
  font-weight: 400;
  margin-top: -15px;
}
</style>
